import { ContextPageSize } from 'pdfmake/interfaces';

import { PdfContent } from '../pdf.type';
import { PdfWorkerSelfType } from '../../pdf-worker.type';

declare const self: PdfWorkerSelfType;

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function footer(
  currentPage: number,
  pageCount: number,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  pageSize: ContextPageSize,
): PdfContent {
  const date = self.serverDate ? new Date(self.serverDate) : new Date();

  return [
    {
      style: 'footer',
      table: {
        widths: ['30%', '40%', '30%'],
        body: [
          [
            {
              text: self.createDate,
              alignment: 'left',
              style: 'footerText',
            },
            {
              // #TODO change this message name
              text: `© ${date.getFullYear()} ${self.allRightsText}`,
              alignment: 'center',
              style: 'footerText',
            },
            {
              text: `${self.i18n.Page} ${currentPage} ${self.i18n.of} ${pageCount}`,
              alignment: 'right',
              style: 'footerText',
            },
          ],
          [
            // #TODO change this message name
            {
              colSpan: 3,
              text: self.footerText,
              alignment: 'center',
              color: '#717073',
              margin: [0, 3, 0, 0],
            },
          ],
        ],
      },
      layout: {
        vLineWidth: (): number => 0,
        hLineWidth: (i): number => (i === 1 ? 1 : 0),
      },
    },
  ];
}

export { footer };
